import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const KnowledgeBaseListAPI = '/knowledge-base-list';
const KnowledgeBaseAddAPI = '/knowledge-base-add';
const KnowledgeBaseUpdateAPI = '/knowledge-base-update/';
const KnowledgeBaseDeleteAPI = '/knowledge-base-delete/';
const KnowledgeBaseGroupAddAPI = '/knowledge-base-group-add';
const KnowledgeBaseGroupUpdateAPI = '/knowledge-base-group-update/';
const KnowledgeBaseGroupDeleteAPI = '/knowledge-base-group-delete/';
const UpdateAiChatSettingAPI = '/admin/v1/update-ai-chat-setting';
const GetAiModelsAPI = '/get-ai-models';

const {
    knowledgeBaseBegin,
    knowledgeBaseSuccess,
    knowledgeBaseErr,
    knowledgeBaseAddBegin,
    knowledgeBaseAddSuccess,
    knowledgeBaseAddErr,
    knowledgeBaseUpdateBegin,
    knowledgeBaseUpdateSuccess,
    knowledgeBaseUpdateErr,
    knowledgeBaseDeleteBegin,
    knowledgeBaseDeleteSuccess,
    knowledgeBaseDeleteErr,
    knowledgeBaseGroupAddBegin,
    knowledgeBaseGroupAddSuccess,
    knowledgeBaseGroupAddErr,
    knowledgeBaseGroupUpdateBegin,
    knowledgeBaseGroupUpdateSuccess,
    knowledgeBaseGroupUpdateErr,
    knowledgeBaseGroupDeleteBegin,
    knowledgeBaseGroupDeleteSuccess,
    knowledgeBaseGroupDeleteErr,
} = actions;

const getKnowledeBaseDetails = (values) => {
    return async (dispatch) => {
        dispatch(knowledgeBaseBegin());
        try {
            const response = await DataService.post(KnowledgeBaseListAPI, values);
            if (response?.data?.status !== HttpStatus.HTTP_OK) {
                dispatch(knowledgeBaseErr(response?.data?.message));
            } else {
                dispatch(knowledgeBaseSuccess(response?.data?.result));
            }
            return response?.data;
        } catch (err) {
            dispatch(knowledgeBaseErr(err));
        }
    };
};

const addKnowledgeBaseItem = (values) => {
    return async (dispatch) => {
        dispatch(knowledgeBaseAddBegin());
        try {
            const response = await DataService.post(KnowledgeBaseAddAPI, values);
            if (response?.data?.status !== HttpStatus.HTTP_OK) {
                dispatch(knowledgeBaseAddErr(response?.data?.message));
            } else {
                dispatch(knowledgeBaseAddSuccess());
            }
            return response?.data;
        } catch (err) {
            dispatch(knowledgeBaseAddErr(err));
        }
    };
};

const updateKnowledgeBaseItem = (slug, values) => {
    return async (dispatch) => {
        dispatch(knowledgeBaseUpdateBegin());
        try {
            const response = await DataService.post(`${KnowledgeBaseUpdateAPI}${slug}`, values);
            if (response?.data?.status !== HttpStatus.HTTP_OK) {
                dispatch(knowledgeBaseUpdateErr(response?.data?.message));
            } else {
                dispatch(knowledgeBaseUpdateSuccess());
            }
            return response?.data;
        } catch (err) {
            dispatch(knowledgeBaseUpdateErr(err));
        }
    };
};

const deleteKnowledgeBaseItem = (slug) => {
    return async (dispatch) => {
        dispatch(knowledgeBaseDeleteBegin());
        try {
            const response = await DataService.delete(`${KnowledgeBaseDeleteAPI}${slug}`);
            if (response?.data?.status !== HttpStatus.HTTP_OK) {
                dispatch(knowledgeBaseDeleteErr(response?.data?.message));
            } else {
                dispatch(knowledgeBaseDeleteSuccess());
            }
            return response?.data;
        } catch (err) {
            dispatch(knowledgeBaseDeleteErr(err));
        }
    };
};

const addKnowledgeBaseGroup = (values) => {
    return async (dispatch) => {
        dispatch(knowledgeBaseGroupAddBegin());
        try {
            const response = await DataService.post(KnowledgeBaseGroupAddAPI, values);
            if (response?.data?.status !== HttpStatus.HTTP_OK) {
                dispatch(knowledgeBaseGroupAddErr(response?.data?.message));
            } else {
                dispatch(knowledgeBaseGroupAddSuccess());
            }
            return response?.data;
        } catch (err) {
            dispatch(knowledgeBaseGroupAddErr(err));
        }
    };
};

const updateKnowledgeBaseGroup = (slug, values) => {
    return async (dispatch) => {
        dispatch(knowledgeBaseGroupUpdateBegin());
        try {
            const response = await DataService.post(`${KnowledgeBaseGroupUpdateAPI}${slug}`, values);
            if (response?.data?.status !== HttpStatus.HTTP_OK) {
                dispatch(knowledgeBaseGroupUpdateErr(response?.data?.message));
            } else {
                dispatch(knowledgeBaseGroupUpdateSuccess());
            }
            return response?.data;
        } catch (err) {
            dispatch(knowledgeBaseGroupUpdateErr(err));
        }
    };
};

const deleteKnowledgeBaseGroup = (slug) => {
    return async (dispatch) => {
        dispatch(knowledgeBaseGroupDeleteBegin());
        try {
            const response = await DataService.delete(`${KnowledgeBaseGroupDeleteAPI}${slug}`);
            if (response?.data?.status !== HttpStatus.HTTP_OK) {
                dispatch(knowledgeBaseGroupDeleteErr(response?.data?.message));
            } else {
                dispatch(knowledgeBaseGroupDeleteSuccess());
            }
            return response?.data;
        } catch (err) {
            dispatch(knowledgeBaseGroupDeleteErr(err));
        }
    };
};

const updateAiChatSetting = (values) => {
    return async (dispatch) => {
        dispatch(knowledgeBaseUpdateBegin());
        try {
            const response = await DataService.post(UpdateAiChatSettingAPI, values);
            if (response?.data?.status !== HttpStatus.HTTP_OK) {
                dispatch(knowledgeBaseUpdateErr(response?.data?.message));
            } else {
                dispatch(knowledgeBaseUpdateSuccess());
            }
            return response?.data;
        } catch (err) {
            dispatch(knowledgeBaseUpdateErr(err));
        }
    };
};

const getAiModels = () => {
    return async (dispatch) => {
        dispatch(knowledgeBaseBegin());
        try {
            const response = await DataService.get(GetAiModelsAPI);
            if (response?.data?.status !== HttpStatus.HTTP_OK) {
                dispatch(knowledgeBaseErr(response?.data?.message));
            } else {
                dispatch(knowledgeBaseSuccess(response?.data?.result));
            }
            return response?.data;
        } catch (err) {
            dispatch(knowledgeBaseErr(err));
        }
    };
};

export {
    getKnowledeBaseDetails,
    addKnowledgeBaseItem,
    updateKnowledgeBaseItem,
    deleteKnowledgeBaseItem,
    addKnowledgeBaseGroup,
    updateKnowledgeBaseGroup,
    deleteKnowledgeBaseGroup,
    getAiModels,
    updateAiChatSetting,
};
